import { ChangeDetectionStrategy, Component, computed, inject, input, LOCALE_ID, output } from '@angular/core';
import { Tables } from '../../../../../../shared/ui/shared-tables/tables/tables';
import { LoadState } from '../../../../../../shared/ui/shared-tables/pagination/pagination.utils';
import { Loading } from '../../../../../../utils/loading/loading';
import { ErrorData } from '../../../../../../utils/error-data/error-data';
import { ActionInterface } from '../../../../../../pages/admin-dashboard/pharmacies/pharmacies-list/pharmacies-list.model';
import { OfferListItem } from '../../../../../../pages/admin-dashboard/promotions/offers-management/offers.model';
import { toOfferTableRows } from './offer-table-component.mapper';

const ACTIONS = {
  view: { id: 1, titleEn: 'View Offer Details', titleAr: 'عرض تفاصيل العرض' },
  edit: { id: 2, titleEn: 'Edit Offer', titleAr: 'تعديل العرض' },
  delete: { id: 3, titleEn: 'Delete Offer', titleAr: 'حذف العرض' },
  // Tables shows id 4 for active rows and id 5 for inactive ones (via row.activationStatus).
  deactivate: { id: 4, titleEn: 'Mark as inactive', titleAr: 'تعيين كغير نشط' },
  activate: { id: 5, titleEn: 'Mark as active', titleAr: 'تعيين كنشط' },
} satisfies Record<string, ActionInterface>;

@Component({
  selector: 'app-offer-table-component',
  imports: [Tables, Loading, ErrorData],
  templateUrl: './offer-table-component.html',
  styleUrl: './offer-table-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferTableComponent {
  private locale = inject(LOCALE_ID);

  /** Offers of the current page only. */
  offers = input<OfferListItem[]>([]);
  state = input<LoadState>('loading');
  errorMessage = input<string>('');
  isFiltersApplied = input<boolean>(false);

  viewOffer = output<string>();
  editOffer = output<string>();
  deleteOffer = output<string>();
  /** Emits the offer id and whether the offer is active right now. */
  toggleOfferActivation = output<{ id: string; isActive: boolean }>();

  isArabic = computed(() => this.locale.startsWith('ar'));

  rows = computed(() => toOfferTableRows(this.offers(), this.isArabic(), this.locale));

  headerItems = [
    { key: 'title', label: $localize`:@@offerName:Offer Name` },
    { key: 'offerType', label: $localize`:@@offerType:Offer Type` },
    { key: 'discount', label: $localize`:@@discountTypeValue:Discount Type/Value` },
    { key: 'duration', label: $localize`:@@startDateEndDate:Start / End Date` },
    { key: 'status', label: $localize`:@@status:Status`, type: 'status' },
    { key: 'actions', label: '', type: 'actions' },
  ];

  currentActions: ActionInterface[] = [
    ACTIONS.view,
    ACTIONS.edit,
    ACTIONS.delete,
    ACTIONS.deactivate,
    ACTIONS.activate,
  ];

  handleAction(e: { event: Event; actionId: number; entity: { id: string } }) {
    e.event?.stopPropagation();
    const id = e.entity.id;
    switch (e.actionId) {
      case ACTIONS.view.id:
        this.viewOffer.emit(id);
        break;
      case ACTIONS.edit.id:
        this.editOffer.emit(id);
        break;
      case ACTIONS.delete.id:
        this.deleteOffer.emit(id);
        break;
      case ACTIONS.deactivate.id:
        this.toggleOfferActivation.emit({ id, isActive: true });
        break;
      case ACTIONS.activate.id:
        this.toggleOfferActivation.emit({ id, isActive: false });
        break;
    }
  }
}
